module.exports = __webpack_public_path__ + "img/vrvr.59abf0d8.webp";